const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      wrapper: '.js-nav-wrapper',
      toggle: '.js-nav-toggle',
    };

    this.classes = {
      open: 'is-open',
      active: 'is-active',
    };

    this.init();
  }

  init() {
    this.bindToggle();
  }

  bindToggle() {
    $(document).on('click', this.selectors.toggle, event => {
      event.preventDefault();
      $(this.selectors.wrapper).toggleClass(this.classes.open);
      $(event.currentTarget)
        .toggleClass(this.classes.active)
        .attr(
          'aria-expanded',
          (i, attr) => (attr === 'true' ? 'false' : 'true'),
        );
    });
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js